import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const CalendarInputRoot = styled.div`
  position: relative;
  width: 100%;
`;

export const CalendarPopup = styled.div`
  position: absolute;
  top: calc(100% + ${pxToRem(8)});
  left: 0;
  z-index: 1100;
  width: max-content;
  max-width: calc(100vw - ${pxToRem(32)});
`;
